import { Operation } from './types';
import type { ActionModifiedChange, ActionRuleGroupingModifiedChange, Change } from './types';

export function isActionRuleGroupingModifiedChange(
  change: Change,
): change is ActionRuleGroupingModifiedChange {
  const { descriptor, op } = change;
  return (
    descriptor === 'action.rules.grouping'
      && op === Operation.Modify
  );
}

export function convertOpToActionModifiedOp(
  change: Change,
): ActionModifiedChange {
  const { actionPublicId } = change;
  return {
    actionPublicId,
    descriptor: 'action',
    op: Operation.Modify,
    value: {
      prev: null,
      next: null,
    },
  };
}
